"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.active = exports.bullet = exports.container = void 0;

var react_1 = require("@emotion/react");

exports.container = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  position: relative;\n  align-items: flex-end;\n  height: 12px;\n  left: 50%;\n  overflow: hidden;\n  transform: translateX(-50%);\n  z-index: 1;\n\n  & > li:not(:last-child) {\n    margin-right: 6px;\n  }\n"])));
exports.bullet = react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-block;\n\n  & > span {\n    display: block;\n    opacity: 0.6;\n    width: 4px;\n    height: 4px;\n    border-radius: 50%;\n    background-color: var(--gray-400);\n  }\n"])));
exports.active = react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  & > span {\n    background-color: var(--gray-700);\n  }\n"])));